import React from 'react';
import FontAwesome from 'react-fontawesome';
import DesignerPreview from './DesignerPreview.js';


class DesignConfirm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            perspectiveIndex: 0
        }

    }

    handleConfirm(e) {
        if (this.state.perspectiveIndex + 1 >= this.props.perspectives.length)
        {
            this.props.onDesignConfirm(true, null);
        }
        else
        {
            this.setState({perspectiveIndex: this.state.perspectiveIndex + 1});
        }
    }

    handleEditPerspective(e) {
        this.props.onDesignConfirm(false, this.props.perspectives[this.state.perspectiveIndex]);
    }

    handleEmptyCallback(e) {

    }

    render() {

        const confirmPerspective = this.props.perspectives[this.state.perspectiveIndex];
        const activeBackground = this.props.backgrounds.find((bg) => {
            return bg.background_id == this.props.selectedBackground.background_id && bg.perspective_id == confirmPerspective.id && bg.perspective_varid == confirmPerspective.varid
        });

        if (activeBackground === undefined)
        {
            this.props.onDesignConfirm(true, null);
            return null;
        }

        return (
            <div className="designer-confirm-modal-wrapper">
                <div className="designer-confirm-modal">
                    <h2>Bestätige deinen selbst gestalteten Artikel</h2>
                    <p>
                        So sieht dein Artikel von {confirmPerspective.title.toLowerCase()} aus:
                    </p>

                    <DesignerPreview
                        activeLayerIndex={this.props.activeLayerIndex}
                        activeBackground={activeBackground}
                        activePerspective={confirmPerspective}
                        activeColor={this.props.activeColor}
                        activeFont={this.props.activeFont}
                        activeDesignerVariants={this.props.activeDesignerVariants}            
                        contentLayers={this.props.contentLayers}
                        designerRenderMode={this.props.designerRenderMode}
                        onContentLayerChange={this.handleEmptyCallback}
                        onContentLayerSelect={this.handleEmptyCallback}
                        onContentLayerRemove={this.handleEmptyCallback}
                        onSymbolSelect={this.handleEmptyCallback}
                    />

                    <p className="text-center">
                        <br />
                        <button className="btn btn-info" onClick={(e) => {this.handleConfirm(e)}}>
                            <FontAwesome name='check' /> &nbsp; Design für die Ansicht {confirmPerspective.title} bestätigen
                        </button> 
                        <br />
                        <button className="btn btn-danger" onClick={(e) => {this.handleEditPerspective(e)}}>
                            <FontAwesome name='times' /> &nbsp; Design bearbeiten
                        </button> 
                    </p>
                </div>
            </div>
        );
    }
}

export default DesignConfirm;



// WEBPACK FOOTER //
// ./src/DesignConfirmModal.js